export const getPageStyleOfTagsWithName = (tagName, styleName, parentElement) => {
  if (!parentElement) parentElement = document.body;
  const el = document.createElement(tagName);
  el.style.display = 'none'; // avoid flickering
  parentElement.appendChild(el);
  const style = window.getComputedStyle(el)[styleName];
  parentElement.removeChild(el);
  return style;
};
